import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { ActionButton, Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as Modals from 'fw/globals/Modals'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class NaicsCodeInfoTab extends SetupTab {
    initialForm() {
        return {
            code: "",
            description: "",
            rowVersion: null
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminNAICSCodeSetupAdd"),
            edit: App.hasPrivilege("AdminNAICSCodeSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/NAICSCodeSetup/getNAICSCodeInfo'),
            save: API.App.url('/NAICSCodeSetup/saveNAICSCodeInfo'),
            create: API.App.url('/NAICSCodeSetup/createNAICSCodeInfo')
        }
    }

    getRequest(selectedId) {
        return {
            code: selectedId
        }
    }

    saveRequest() {
        return {
            code: this.state.form.code,
            description: this.state.form.description,
            rowVersion: this.state.form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    handleDelete = () => {
        const me = this;
        Modals.remove({
            title: "Deleting NAICS Code",
            elementType: "NAICSCode",
            name: this.state.form.code,
            onYes: () => {
                API.App.post('/NAICSCodeSetup/deleteNAICSCode', { code: me.props.selectedId },
                {
                    success: (r) => {
                        me.props.onSuccess(r.message);
                        me.props.onDelete();
                    },
                    error: (r) => {
                        me.props.onError(r.error);
                    }
                });
            }
        });
    }


    renderActions() {
        if (this.state.adding)
            return null;

        return (
            <div className="pull-right">
                    <ActionButton id="btnDeleteUser" onClick={this.handleDelete} icon="trash">Delete NAICS Code</ActionButton>
            </div>
        )
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Label required>Code</Label>
                            <TextBox 
                                name="code" 
                                placeholder="Code"
                                maxLength={6} 
                                required 
                                ref={(c) => { this.focusControl = c; }} />
                        </FormGroup>
                    </Col>
                    <Col md={8}>
                        <FormGroup>
                            <Label required>Description</Label>
                            <TextBox 
                                name="description" 
                                placeholder="Description"
                                required 
                                maxLength={140} />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default NaicsCodeInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/naicsCodeSetup/naicsCodeInfo/NaicsCodeInfoTab.js